<template>
  <transition name="slide-down">
    <div v-if="show" id="splash">
      <div class="content">
        <img
          src="../assets/i/images/datalboran-splash.png"
          alt="Pantalla de carga"
        >
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['time'],
  data () {
    return {
      show: 1
    }
  },
  mounted () {
    setTimeout(() => {
      this.show = false
    }, this.time)
  }
}
</script>
